import React, { useState, useEffect, useRef } from 'react';
import styled from '@emotion/styled';
import MultilevelSidebar from './MultilevelSidebar';
import { ToggleV2 } from 'swui';
import SliderDesktopNotification from './SidebarToggle/SliderDesktopNotification';
import SliderGoogleToggle from './SidebarToggle/SliderGoogleToggle';
import PopupForSecurity from './SidebarToggle/PopupForSecurity';
import RequestForInformation from './SidebarToggle/RequestForInformation';
import SidebarHeader from './SidebarHeader';
import { getBrowserDetails, isDarkMode, termsOfUseUrl } from '../../../../utils/helpers';
import { SvgIcon, Typography } from '@material-ui/core';
import Button from '../../../../atoms/buttons/Button';
import { clearAllBodyScrollLocks } from 'body-scroll-lock';
import { isUVPAA } from '../../../../utils/webAuthn';
import {
  ExitToAppOutlined,
  NotificationsActiveOutlined,
  SecurityOutlined,
  SettingsOutlined,
  HelpOutlineOutlined,
  FingerprintOutlined,
  ImportExportOutlined,
  UpdateOutlined,
  ContactPhoneOutlined,
  LaunchOutlined,
  RemoveCircleOutlineOutlined,
  LocalPhone,
  BlockOutlined,
} from '@material-ui/icons';
import UserNavItem from '../UserNavItem';
import MasterConfig from '../../../../config/Master';
import 'react-multilevel-sidebar/src/Sidebar.css';
import './sidebar.css';
import { sendPurchaseAccountMenuBuyCreditAction } from '../../../../actions/purchaseActions';
import useMixPanel from '../../../../hooks/useMixPanel';
import PaymentSettingsIcon from '../../../../atoms/icons/PaymentSettingsIcon';
import PaymentSettings from './PaymentSettings/PaymentSettings';
import EditPhoneForm from '../../../phone/phoneSettings/EditPhoneForm';
import DeactivateAccount from './DeactivateAccount/DeactivateAccount';
import { handleDeactivateAccountVysionEvent } from '../../../../utils/vysion/deactivateAccount';
import { DeactivateAccountClickVysionEventsEnum } from '../../../../utils/vysion/deactivateAccount/click';
import { DeactivateAccountViewVysionEventsEnum } from '../../../../utils/vysion/deactivateAccount/view';
import { VYSION_ACTIONS } from '../../../../utils/vysion';
import { useApp } from '../../../../contexts/AppContext';
import PWASidebarBanner from '../../../../components/pwa/PWASidebarBanner';
import SecondaryButton from '../../../../atoms/buttons/SecondaryButton';
import { getVideoCallSettings, resetHiddenDialogs, setDarkMode } from '../../../../actions/profileActions';
import { connect, useDispatch, useSelector } from 'react-redux';
import { doNotShowDeclineOfferConfirmationKey } from '../../../../hooks/useModal';
import useNotificationBanner from '../../../../hooks/useNotificationBanner';
import { toggleDarkMode } from '../../../../sdk/SettingsSDK';
import { FONT_FAMILIES } from '../../../../theme/material/constants';
import { mixpanelTrackEvent } from '../../../../utils/mixpanel/common';
import { EVENT_NAMES } from '../../../../constants/mixpanel';
import PrivacyDismissedMemberIcon from '../../../../atoms/icons/PrivacyDismissedMemberIcon';
import PrivacyBlockedIcon from '../../../../atoms/icons/PrivacyBlockedIcon';
import PrivacyReportingAbuseIcon from '../../../../atoms/icons/PrivacyReportingAbuseIcon';
import PrivacySafeDatingTipsIcon from '../../../../atoms/icons/PrivacySafeDatingTipsIcon';
import PrivacyPreferencesIcon from '../../../../atoms/icons/PrivacyPreferencesIcon';
import PrivacyPreferences from '../../../pages/PrivacyPreferences/PrivacyPreferences';
import SliderAppleToggle from './SidebarToggle/SliderAppleToggle';
import { RootState } from '../../../../store';
import IDVVerification from '../../../../modules/IDVVerification';
import SelfieVerification from '../../../../modules/SVVerification';
import ChangeEmailIcon from 'atoms/icons/ChangeEmailIcon';
import { getInputTheme } from 'style';
import useCookieConsentCheck from '../../../../hooks/useCookieConsentCheck';

const commonStyles = () => ({
  fontSize: 26,
  color: isDarkMode() ? '#71B5E4' : '#0D5C93',
  stroke: isDarkMode() ? '#71B5E4' : '#0D5C93',
  strokeWidth: '0.5px',
});

const UserNavItemContainerStyled = styled('div')(
  {
    display: 'flex',
    justifyContent: 'flex-end',
    flex: 1,
  },
  () => {
    return {
      '.phoneInput, .phoneButton': {
        color: getInputTheme().colorInput + ' !important',
      },
    };
  }
);

const parentMenuItems = [1, 2, 11, 20, 31, 38, 40, 42];

const mapArrayToObj = arr => {
  return arr.reduce((map, obj) => {
    map[obj.key] = obj.val;
    return map;
  }, {});
};

const getStyledButton = () => ({
  height: 33,
  width: 158,
  fontSize: 13,
  fontFamily: FONT_FAMILIES.primary,
  fontWeight: 700,
  border: 'none',
  lineHeight: '11px',
  padding: '11px 24px',
  borderRadius: 4,
});

const StyledToggle = styled(ToggleV2)({
  height: '28px !important',
  width: '54px !important',
});

const options = (
  objOptions,
  trackPackagesPageVisited,
  hashId: string,
  isAccountIsMixpanelEligableEnabled: boolean,
  resetHiddenDialogs: () => void
) => {
  const permission = window.Notification ? window.Notification.permission : false;
  const videoCall = objOptions['settings'].video_call;

  return [
    {
      content: objOptions['canUpgrade']
        ? [
            {
              id: 1,
              name: (
                <Typography
                  variant="body1"
                  style={{
                    fontSize: 18,
                    lineHeight: '23px',
                    letterSpacing: -0.5,
                    color: isDarkMode() ? '#F6F4F4' : '#595959',
                  }}
                >{`${objOptions['credits']} Credits`}</Typography>
              ),
              icon: (
                <Button
                  customStyle={getStyledButton()}
                  buttonType="gradientTeal"
                  onClick={() => {
                    sendPurchaseAccountMenuBuyCreditAction();
                    trackPackagesPageVisited({ Source: 'Buy Credits Menu' });
                  }}
                  buttonTextCustomStyle={{
                    fontWeight: 700,
                    fontSize: 16,
                    lineHeight: '16px',
                    letterSpacing: -0.32,
                  }}
                >
                  BUY CREDITS
                </Button>
              ),
              to: '/packages',
              link: true,
            },
          ]
        : [{ hidden: true }],
    },
    {
      hideBorder: true,
      content: [
        {
          id: 40,
          name: 'Dark Mode',
          icon: (
            <StyledToggle
              id="dark_mode"
              className="sidebarToggle"
              checked={objOptions['allowDarkMode'] ? objOptions['allowDarkMode'] : false}
              onChange={objOptions['allowThemeOS']}
              // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
              defaultValue={false}
            />
          ),
        },
        {
          id: 2,
          name: 'Notifications',
          icon: <SvgIcon component={NotificationsActiveOutlined} style={commonStyles()} />,
          children: [
            {
              title: 'App Notifications',
              hideBorder: true,
              content: [
                permission
                  ? {
                      id: 3,
                      name: permission === 'granted' ? 'Push Notifications' : '',
                      icon: (
                        <SliderDesktopNotification
                          status={objOptions['settings'].desktopNotificationStatus}
                          toggleDesktopNotification={objOptions['toggleDesktopNotificationStatus']}
                        />
                      ),
                    }
                  : { hidden: true },
                {
                  id: 4,
                  name: 'Getting Favorited',
                  icon: (
                    <StyledToggle
                      id="alert_favorite"
                      className="sidebarToggle"
                      checked={objOptions['settings'].alert_favorite ? objOptions['settings'].alert_favorite : false}
                      onChange={objOptions['updateAccountSetting']}
                    />
                  ),
                },
                {
                  id: 5,
                  name: 'New Offers',
                  icon: (
                    <StyledToggle
                      id="alert_offer"
                      className="sidebarToggle"
                      checked={objOptions['settings'].alert_offer ? objOptions['settings'].alert_offer : false}
                      onChange={objOptions['updateAccountSetting']}
                    />
                  ),
                },
                {
                  id: 6,
                  name: 'New Messages',
                  icon: (
                    <StyledToggle
                      id="alert_mail"
                      className="sidebarToggle"
                      checked={objOptions['settings'].alert_mail ? objOptions['settings'].alert_mail : false}
                      onChange={objOptions['updateAccountSetting']}
                    />
                  ),
                },
                {
                  id: 44,
                  name: 'Reset Hidden Dialogs',
                  icon: (
                    <SecondaryButton
                      label="Reset"
                      onClick={resetHiddenDialogs}
                      color="blue"
                      size="x-small"
                      customStyle={{
                        width: 70,
                      }}
                    />
                  ),
                  link: true,
                },
              ],
            },
            {
              title: 'Email Me',
              hideBorder: true,
              content: [
                {
                  id: 7,
                  name: 'New Members',
                  icon: (
                    <StyledToggle
                      id="notify_new_members"
                      className="sidebarToggle"
                      checked={
                        objOptions['settings'].notify_new_members ? objOptions['settings'].notify_new_members : false
                      }
                      onChange={objOptions['updateAccountSetting']}
                    />
                  ),
                },
                {
                  id: 8,
                  name: 'Favorites',
                  icon: (
                    <StyledToggle
                      id="notify_favorite"
                      className="sidebarToggle"
                      checked={objOptions['settings'].notify_favorite ? objOptions['settings'].notify_favorite : false}
                      onChange={objOptions['updateAccountSetting']}
                    />
                  ),
                },
                {
                  id: 9,
                  name: 'New Offers',
                  icon: (
                    <StyledToggle
                      id="notify_offer"
                      className="sidebarToggle"
                      checked={objOptions['settings'].notify_offer ? objOptions['settings'].notify_offer : false}
                      onChange={objOptions['updateAccountSetting']}
                    />
                  ),
                },
                {
                  id: 10,
                  name: 'New Messages',
                  icon: (
                    <StyledToggle
                      id="notify_message"
                      className="sidebarToggle"
                      checked={objOptions['settings'].notify_message ? objOptions['settings'].notify_message : false}
                      onChange={objOptions['updateAccountSetting']}
                    />
                  ),
                },
              ],
            },
          ],
        },
      ],
    },
    {
      hideBorder: true,
      content: [
        {
          id: 11,
          name: 'Privacy & Safety',
          icon: <SvgIcon component={SecurityOutlined} style={commonStyles()} />,
          children: [
            {
              title: 'Visibility',
              hideBorder: true,
              content: [
                {
                  id: 12,
                  name: 'Hide me from Search Results',
                  icon: (
                    <StyledToggle
                      id="hidden"
                      className="sidebarToggle"
                      checked={objOptions['settings'].hidden ? objOptions['settings'].hidden : false}
                      onChange={e => {
                        mixpanelTrackEvent({
                          eventName: EVENT_NAMES.TOGGLE_HIDE_ME_FROM_SEARCH_RESULTS,
                          payload: {
                            eventProperties: {
                              Status: objOptions['settings'].hidden ? 'Deactivated' : 'Activated',
                            },
                            userProperties: {
                              'Hidden from Search': !objOptions['settings'].hidden,
                            },
                          },
                        });

                        objOptions['updateAccountSetting'](e);
                      }}
                    />
                  ),
                },
                {
                  id: 13,
                  name: 'Hide my online status & login date',
                  icon: (
                    <StyledToggle
                      id="hidden_last_login_dt"
                      className="sidebarToggle"
                      checked={
                        objOptions['settings'].hidden_last_login_dt
                          ? objOptions['settings'].hidden_last_login_dt
                          : false
                      }
                      onChange={e => {
                        mixpanelTrackEvent({
                          eventName: EVENT_NAMES.TOGGLE_HIDE_MY_ONLINE_STATUS_LOGIN_DATE,
                          payload: {
                            eventProperties: {
                              Status: objOptions['settings'].hidden_last_login_dt ? 'Deactivated' : 'Activated',
                            },
                            userProperties: {
                              'Online status & login date hidden': !objOptions['settings'].hidden_last_login_dt,
                            },
                          },
                        });

                        objOptions['updateAccountSetting'](e);
                      }}
                    />
                  ),
                },
                {
                  id: 14,
                  name: 'Hide profile views',
                  icon: (
                    <StyledToggle
                      id="hidden_view"
                      className="sidebarToggle"
                      checked={objOptions['settings'].hidden_view ? objOptions['settings'].hidden_view : false}
                      onChange={e => {
                        mixpanelTrackEvent({
                          eventName: EVENT_NAMES.TOGGLE_HIDE_PROFILE_VIEWS,
                          payload: {
                            eventProperties: {
                              Status: objOptions['settings'].hidden_view ? 'Deactivated' : 'Activated',
                            },
                            userProperties: {
                              'Profile views hidden': !objOptions['settings'].hidden_view,
                            },
                          },
                        });

                        objOptions['updateAccountSetting'](e);
                      }}
                    />
                  ),
                },
              ],
            },
            {
              title: 'Video Calls',
              hideBorder: true,
              content: [
                {
                  id: 15,
                  name: 'Block incoming video call',
                  icon: (
                    <StyledToggle
                      id="block_incoming"
                      className="sidebarToggle"
                      checked={videoCall ? videoCall.block_incoming : false}
                      onChange={objOptions['updateVideoSetting']}
                    />
                  ),
                },
                {
                  id: 16,
                  name: `Only receive calls from people I've conversed with`,
                  icon: (
                    <StyledToggle
                      id="have_conversed"
                      className="sidebarToggle"
                      checked={videoCall ? (videoCall?.have_conversed ?? false) : false}
                      onChange={objOptions['updateVideoSetting']}
                    />
                  ),
                },
              ],
            },
            {
              title: 'Dating Safely',
              hideBorder: true,
              content: [
                {
                  id: 45,
                  name: 'Dismissed Members List',
                  icon: <PrivacyDismissedMemberIcon color={isDarkMode() ? '#71B5E4' : '#0D5C93'} />,
                  to: '/dismissed',
                  link: true,
                },
                {
                  id: 17,
                  name: 'Blocked Members List',
                  icon: <PrivacyBlockedIcon color={isDarkMode() ? '#71B5E4' : '#0D5C93'} />,
                  to: '/blocked',
                  link: true,
                },
                {
                  id: 18,
                  name: 'Reporting Abuse',
                  icon: <PrivacyReportingAbuseIcon color={isDarkMode() ? '#D06369' : '#E21D4A'} />,
                  to: `${MasterConfig.FULL_URL}/faq/giving-feedback`,
                  link: true,
                  fullurl: true,
                },
                {
                  id: 19,
                  name: 'Safe Dating Tips',
                  icon: <PrivacySafeDatingTipsIcon color={isDarkMode() ? '#71B5E4' : '#0D5C93'} />,
                  to: `${MasterConfig.FULL_URL}/blog/tips-for-dating-safely-during-covid-and-after`,
                  link: true,
                  fullurl: true,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      hideBorder: true,
      content: [
        {
          id: 20,
          name: 'Account Settings',
          key: 'account-settings',
          icon: <SvgIcon component={SettingsOutlined} style={commonStyles()} />,
          children: [
            {
              title: 'Login Options',
              hideBorder: true,
              content: [
                objOptions['isGoogleSsoEnabled']
                  ? {
                      id: 21,
                      name: 'Login with Google',
                      icon: (
                        <SliderGoogleToggle
                          isDisabled={false}
                          needsAccountPassword={objOptions['needsAccountPasswordGoogle']}
                          social={objOptions['settings'].social}
                          attachSocialLogin={objOptions['attachSocialLogin']}
                          handleSidebarToggle={objOptions['handleSidebarToggle']}
                          menuOpen={objOptions['menuOpen']}
                        />
                      ),
                    }
                  : { hidden: true },
                objOptions['isAppleSsoEnabled']
                  ? {
                      id: 21,
                      name: 'Login with Apple',
                      icon: (
                        <SliderAppleToggle
                          isDisabled={false}
                          needsAccountPassword={objOptions['needsAccountPasswordApple']}
                          social={objOptions['settings'].social}
                          attachSocialLogin={objOptions['attachSocialLogin']}
                          handleSidebarToggle={objOptions['handleSidebarToggle']}
                          menuOpen={objOptions['menuOpen']}
                        />
                      ),
                    }
                  : { hidden: true },
                isUVPAA()
                  ? {
                      id: 22,
                      name: 'Biometric Sign In',
                      icon: <SvgIcon component={FingerprintOutlined} style={commonStyles()} />,
                      to: '/biometrics',
                      link: true,
                      hidden: true,
                    }
                  : { hidden: true },
                {
                  id: 23,
                  name: '',
                  icon: (
                    <PopupForSecurity
                      handleSidebarToggle={objOptions['handleSidebarToggle']}
                      destroyOtherDeviceSession={objOptions['destroyOtherDeviceSession']}
                      menuOpen={objOptions['menuOpen']}
                    />
                  ),
                },
                {
                  id: 41,
                  name: 'Change Phone Number',
                  hasSecondChild: true,
                  icon: <SvgIcon component={LocalPhone} style={commonStyles()} />,
                  children: [
                    {
                      title: '',
                      hideBorder: true,
                      isCustomComponent: true,
                      content: <EditPhoneForm />,
                    },
                  ],
                },
                {
                  id: 24,
                  name: `Change Email`,
                  icon: <SvgIcon component={ChangeEmailIcon} style={commonStyles()} />,
                  to: '/settings/email-password',
                  link: true,
                },
              ],
            },
            {
              title: 'Account History',
              hideBorder: true,
              content: [
                {
                  id: 25,
                  name: 'Canceled Offers',
                  icon: <SvgIcon component={ImportExportOutlined} style={commonStyles()} />,
                  to: '/cancelled-offers',
                  link: true,
                },
                {
                  id: 26,
                  name: 'Purchase History',
                  icon: <SvgIcon component={UpdateOutlined} style={commonStyles()} />,
                  to: '/credits',
                  link: true,
                },
              ],
            },

            {
              title: 'Data Protection',
              hideBorder: true,
              content: [
                objOptions['isPrivacyPreferencesQualified']
                  ? {
                      id: 27,
                      name: 'Privacy Preferences',
                      key: 'privacy-preferences',
                      title: 'Privacy Preferences',
                      hasSecondChild: true,
                      icon: <PrivacyPreferencesIcon />,
                      children: [
                        {
                          title: '',
                          hideBorder: true,
                          isCustomComponent: true,
                          content: <PrivacyPreferences />,
                        },
                      ],
                    }
                  : { hidden: true },
                {
                  id: 28,
                  name: '',
                  icon: (
                    <RequestForInformation
                      userInfo={objOptions['settings'].userInfo}
                      requestUserInfo={objOptions['requestUserInfo']}
                    />
                  ),
                },
                {
                  id: 29,
                  name: 'Revoke Consent',
                  icon: <SvgIcon component={RemoveCircleOutlineOutlined} style={commonStyles()} />,
                  to: '/gdpr-delete',
                  link: true,
                },
                {
                  id: 30,
                  name: 'Deactivate or Delete My Account',
                  title: 'Deactivate My Account',
                  key: 'deactivate-my-account',
                  hasSecondChild: true,
                  icon: (
                    <SvgIcon
                      component={BlockOutlined}
                      style={{
                        ...commonStyles(),
                        ...{
                          color: isDarkMode() ? '#FF5959' : '#DD0B24',
                          stroke: isDarkMode() ? '#FF5959' : '#DD0B24',
                        },
                      }}
                    />
                  ),
                  children: [
                    {
                      title: '',
                      hideBorder: true,
                      isCustomComponent: true,
                      content: <DeactivateAccount isGenerous={objOptions['canUpgrade']} />,
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      hideBorder: true,
      content: objOptions['canUpgrade']
        ? [
            {
              id: 42,
              name: 'Payment Settings',
              icon: <PaymentSettingsIcon />,
              children: [
                {
                  title: '',
                  hideBorder: true,
                  isCustomComponent: true,
                  content: (
                    <PaymentSettings
                      menuOpen={objOptions['menuOpen']}
                      settings={objOptions['settings']}
                      getRecurringPackages={objOptions['getRecurringPackages']}
                      subscribeRecurringPayment={objOptions['subscribeRecurringPayment']}
                      unSubscribeRecurringPayment={objOptions['unSubscribeRecurringPayment']}
                      getRecurringPayment={objOptions['getRecurringPayment']}
                      removeSavedToken={objOptions['removeSavedToken']}
                    />
                  ),
                },
              ],
            },
          ]
        : [{ hidden: true }],
    },
    {
      hideBorder: true,
      content: [
        {
          id: 31,
          name: 'Help Center',
          icon: <SvgIcon component={HelpOutlineOutlined} style={commonStyles()} />,
          children: [
            {
              title: 'Help',
              hideBorder: true,
              content: [
                {
                  id: 32,
                  name: 'Frequently Asked Questions',
                  icon: <SvgIcon component={HelpOutlineOutlined} style={commonStyles()} />,
                  to: `${MasterConfig.FULL_URL}/faq`,
                  link: true,
                  fullurl: true,
                },
                {
                  id: 33,
                  name: 'Contact Support',
                  icon: <SvgIcon component={ContactPhoneOutlined} style={commonStyles()} />,
                  to: `${MasterConfig.FULL_URL}/faq/giving-feedback`,
                  link: true,
                  fullurl: true,
                },
              ],
            },
            {
              title: 'Site Information',
              hideBorder: true,
              content: [
                {
                  id: 34,
                  name: 'Privacy Policy',
                  icon: <SvgIcon component={LaunchOutlined} style={commonStyles()} />,
                  to: `${MasterConfig.FULL_URL}/privacy`,
                  link: true,
                  fullurl: true,
                },
                {
                  id: 35,
                  name: 'Terms Of Use',
                  icon: <SvgIcon component={LaunchOutlined} style={commonStyles()} />,
                  to: termsOfUseUrl(false),
                  link: true,
                  fullurl: true,
                },
                {
                  id: 36,
                  name: 'Community Guidelines',
                  icon: <SvgIcon component={LaunchOutlined} style={commonStyles()} />,
                  to: `${MasterConfig.FULL_URL}/community-guidelines`,
                  link: true,
                  fullurl: true,
                },
                {
                  id: 37,
                  name: 'GDPR',
                  icon: <SvgIcon component={LaunchOutlined} style={commonStyles()} />,
                  to: `https://gdpr-info.eu/`,
                  link: true,
                  fullurl: true,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      hideBorder: true,
      content: [
        {
          id: 39,
          name: 'IDV Status',
          noLabel: true,
          icon: (
            <div style={{ display: 'flex', width: '100%', flexDirection: 'column', gap: 10 }}>
              <SelfieVerification sideBar={true} />
              <IDVVerification account={objOptions['account']} sideBar={true} />
            </div>
          ),
          link: false,
        },
      ],
    },
    {
      hideBorder: true,
      content: [
        objOptions['showAccountInfo'] &&
        objOptions['settings'].userInfo &&
        objOptions['settings'].userInfo.status === 'finished'
          ? {
              id: 40,
              icon: (
                <RequestForInformation
                  userInfo={objOptions['settings'].userInfo}
                  requestUserInfo={objOptions['requestUserInfo']}
                />
              ),
              hidden: false,
            }
          : {},
      ],
    },
    {
      hideBorder: true,
      content: [
        {
          id: 38,
          name: 'Log Out',
          icon: (
            <SvgIcon
              component={ExitToAppOutlined}
              style={{
                ...commonStyles(),
                color: isDarkMode() ? '#FF3A67' : '#E21D4A',
                stroke: isDarkMode() ? '#FF3A67' : '#E21D4A',
              }}
            />
          ),
          to: '/logout',
          link: true,
          replace: true,
        },
      ],
    },
    {
      hideBorder: false,
      isCustomComponent: true,
      content: <PWASidebarBanner />,
    },
  ];
};

interface SliderSidebarProps {
  avatar: any;
  credits: any;
  username: any;
  canUpgrade: any;
  settings: any;
  updateAccountSetting: any;
  updateVideoSetting: any;
  handleSidebarToggle: any;
  attachSocialLogin: any;
  menuOpen: any;
  navBarHeight: any;
  toggleDesktopNotificationStatus: any;
  destroyOtherDeviceSession: any;
  requestUserInfo: any;
  deleteGDPRForm: any;
  errors: any;
  clearNotificationMessage: any;
  clearErrors: any;
  validateCredentials: any;
  data: any;
  hashId: any;
  hasNotify: any;
  handleSidebarHide: any;
  getCheckInfoRequest: any;
  revertBackLastUpdate: any;
  updatingSettings: any;
  lastUpdate: any;
  isMobile: any;
  showAccountInfo: any;
  requiredVerification: any;
  account: any;
  getRecurringPackages: any;
  subscribeRecurringPayment: any;
  unSubscribeRecurringPayment: any;
  getRecurringPayment: any;
  removeSavedToken: any;
  resetHiddenDialogsProp: () => void;
}

const SliderSidebar = ({
  avatar,
  credits,
  username,
  canUpgrade,
  settings,
  updateAccountSetting,
  updateVideoSetting,
  handleSidebarToggle,
  attachSocialLogin,
  menuOpen,
  navBarHeight,
  toggleDesktopNotificationStatus,
  destroyOtherDeviceSession,
  requestUserInfo,
  deleteGDPRForm,
  errors,
  clearNotificationMessage,
  clearErrors,
  validateCredentials,
  data,
  hashId,
  hasNotify,
  handleSidebarHide,
  getCheckInfoRequest,
  revertBackLastUpdate,
  updatingSettings,
  lastUpdate,
  isMobile,
  showAccountInfo,
  requiredVerification,
  account,
  getRecurringPackages,
  subscribeRecurringPayment,
  unSubscribeRecurringPayment,
  getRecurringPayment,
  removeSavedToken,
  resetHiddenDialogsProp,
  ...rest
}: SliderSidebarProps): any => {
  // create a sidebar component so we can use our own hamburger icon and manage the cutsomization internally
  const [GDPR, setGDPR] = useState(false);
  const buyCredits = useRef(null);
  const { isAccountIsMixpanelEligableEnabled } = useApp();
  const { showNotificationBanner } = useNotificationBanner();

  const { trackPageView, trackPackagesPageVisited } = useMixPanel();
  const dispatch = useDispatch();
  const allowDarkMode = isDarkMode();
  const { isQualified: isPrivacyPreferencesQualified } = useCookieConsentCheck();

  const { is_google_SSO_enabled, is_apple_SSO_enabled } = useSelector((state: RootState) => state.settings);

  useEffect(() => {
    // do componentDidMount logic
    dispatch(getVideoCallSettings());
    getCheckInfoRequest && getCheckInfoRequest();
    buyCredits.current = document.getElementById(`${credits} Credits-Section`);
    if (buyCredits && buyCredits.current) {
      buyCredits.current.addEventListener(
        'click',
        () => {
          sendPurchaseAccountMenuBuyCreditAction();
          trackPackagesPageVisited({ Source: 'Buy Credits Menu' });
        },
        false
      );

      return () => {
        buyCredits.current.removeEventListener('click', () => null, false);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const allowThemeOS = () => {
    document.getElementById('sidebar-parent').style.transition = 'none';
    const { isMobile } = getBrowserDetails();
    const deviceKey = isMobile ? 'mobile' : 'desktop';

    dispatch(
      setDarkMode({
        [deviceKey]: !allowDarkMode,
      })
    );
    toggleDarkMode({ darkmode: !allowDarkMode }).then(() => {
      mixpanelTrackEvent({
        eventName: EVENT_NAMES.DARK_MODE_ENABLED,
        payload: {
          eventProperties: {
            'Dark Mode Enabled': !allowDarkMode,
          },
        },
      });
    });

    setTimeout(() => {
      document.getElementById('sidebar-parent').style.transition = 'all 0.5s ease-in-out';
    }, 100);
  };

  const handleClick = itemOptions => {
    if (itemOptions.id === 2) {
      trackPageView('menu_notifications');
    }

    if (itemOptions.id === 11) {
      trackPageView('menu_privacy_safety');
    }

    if (itemOptions.name === 'Deactivate or Delete My Account') {
      handleDeactivateAccountVysionEvent({
        event: DeactivateAccountClickVysionEventsEnum.ACCOUNT_MENU_ACCOUNT_SETTINGS_DEACTIVATE_OR_DELETE_MY_ACCOUNT,
      });

      /**
       * Put view event here
       * because it doesn't work when put in DeactivateAccount component
       * Technically, when this menu is clicked, the DeactivateAccount will show up
       */
      handleDeactivateAccountVysionEvent({
        event: DeactivateAccountViewVysionEventsEnum.ACCOUNT_MENU_DEACTIVATE__ACCOUNT,
        action: VYSION_ACTIONS.VIEW,
      });
      trackPageView('deactivate_or_delete_my_account');
    }

    if (itemOptions.link) {
      handleSidebarToggle(!menuOpen);
    }
  };

  const handleGDPRRequest = () => {
    setGDPR(!GDPR);
  };

  const clearLastUpdate = itemOptions => {
    if (itemOptions.includes(2)) {
      trackPageView('menu_notifications');
    }

    if (itemOptions.includes(11)) {
      trackPageView('menu_privacy_safety');
    }
    GDPR && handleGDPRRequest();
    revertBackLastUpdate();
  };

  const unlockPage = () => {
    clearAllBodyScrollLocks();
  };

  const resetHiddenDialogs = () => {
    // Pass modal (Discover mode - swipe left)
    // Send Offer modal (Discover mode - swipe right)
    resetHiddenDialogsProp();

    /// Decline modal:
    localStorage.removeItem(doNotShowDeclineOfferConfirmationKey);

    showNotificationBanner({ type: 'success', message: 'All dialogs have been reset' });
  };

  const canDetachSocialAccount = (site: string): boolean => {
    const { social } = settings;

    if (!social?.data || social?.data?.length <= 0) {
      return false;
    }

    if (social.data.length > 1) {
      return false;
    }

    return social.data.some((item: any) => item.email === account.email && item.social_site_name == site);
  };

  return (
    <UserNavItemContainerStyled>
      <UserNavItem
        credits={credits}
        clickHandler={handleSidebarToggle}
        navHeight={navBarHeight}
        username={username}
        avatar={avatar}
        canUpgrade={canUpgrade}
        isMobile={isMobile}
      />
      {settings && (
        <MultilevelSidebar
          // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
          isMobile={isMobile}
          open={menuOpen}
          onToggle={handleSidebarToggle}
          onToggleHide={handleSidebarHide}
          hasNotify={hasNotify}
          options={options(
            mapArrayToObj([
              { key: 'menuOpen', val: menuOpen },
              { key: 'handleSidebarToggle', val: handleSidebarToggle },
              { key: 'credits', val: credits },
              { key: 'canUpgrade', val: canUpgrade },
              { key: 'settings', val: settings },
              { key: 'updateAccountSetting', val: updateAccountSetting },
              { key: 'updateVideoSetting', val: updateVideoSetting },
              { key: 'toggleDesktopNotificationStatus', val: toggleDesktopNotificationStatus },
              { key: 'attachSocialLogin', val: attachSocialLogin },
              { key: 'needsAccountPasswordGoogle', val: canDetachSocialAccount('google') },
              { key: 'needsAccountPasswordApple', val: canDetachSocialAccount('apple') },
              { key: 'destroyOtherDeviceSession', val: destroyOtherDeviceSession },
              { key: 'requestUserInfo', val: requestUserInfo },
              { key: 'deleteGDPRForm', val: deleteGDPRForm },
              { key: 'errors', val: errors },
              { key: 'clearNotificationMessage', val: clearNotificationMessage },
              { key: 'clearErrors', val: clearErrors },
              { key: 'validateCredentials', val: validateCredentials },
              { key: 'handleGDPRRequest', val: handleGDPRRequest },
              { key: 'GDPR', val: GDPR },
              { key: 'allowDarkMode', val: allowDarkMode },
              { key: 'allowThemeOS', val: allowThemeOS },
              { key: 'showAccountInfo', val: showAccountInfo },
              { key: 'requiredVerification', val: requiredVerification },
              { key: 'account', val: account },
              { key: 'getRecurringPackages', val: getRecurringPackages },
              { key: 'subscribeRecurringPayment', val: subscribeRecurringPayment },
              { key: 'unSubscribeRecurringPayment', val: unSubscribeRecurringPayment },
              { key: 'getRecurringPayment', val: getRecurringPayment },
              { key: 'removeSavedToken', val: removeSavedToken },
              { key: 'isGoogleSsoEnabled', val: is_google_SSO_enabled },
              { key: 'isAppleSsoEnabled', val: is_apple_SSO_enabled },
              { key: 'isPrivacyPreferencesQualified', val: isPrivacyPreferencesQualified },
            ]),
            trackPackagesPageVisited,
            hashId,
            isAccountIsMixpanelEligableEnabled,
            resetHiddenDialogs
          )}
          header={
            <SidebarHeader
              handleSidebarToggle={handleSidebarToggle}
              con
              avatar={avatar}
              username={username}
              hashId={hashId}
              isVerified={data.profile.id_verification?.data?.status === 'approved'}
              isSelfieVerified={data?.profile?.profile?.data?.selfie_verified}
            />
          }
          onItemClick={handleClick}
          onBackClick={clearLastUpdate}
          width={isMobile ? '100%' : 428}
          updatingSettings={updatingSettings}
          lastUpdate={lastUpdate}
          GDPR={GDPR}
          parentMenuItems={parentMenuItems}
          onClose={unlockPage}
          {...rest}
        />
      )}
    </UserNavItemContainerStyled>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    resetHiddenDialogsProp: () => {
      dispatch(resetHiddenDialogs());
    },
  };
};

export default connect(null, mapDispatchToProps)(SliderSidebar);
